module.exports = "../study/imgs/maps/Nagano/S8/Ecosystem/Fagus/Nagano_Fagus_GFDL_RCP85_Now.png";